__turbopack_context__.v({
  "icon": "Pixl-module__mZwPYW__icon",
});
